export default __webpack_public_path__ + "static/media/cavemenClashingMobile2x.2d7d394a.png";